/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/New/Patient/Content/PatientSearch/Results/Loading"
  
}) {
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-2mx3jB': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--mt-2-2mx3jB': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 height={56}
 width="100%"
 delay={0}
 backgroundColorForeground={dtColorsNeutral100}
 backgroundColorBackground={dtColorsWhite}
/>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 height={56}
 width="100%"
 delay={50}
 backgroundColorForeground={dtColorsNeutral100}
 backgroundColorBackground={dtColorsWhite}
/>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 height={56}
 width="100%"
 delay={100}
 backgroundColorForeground={dtColorsNeutral100}
 backgroundColorBackground={dtColorsWhite}
/>
</div>
{children}
</React.Fragment>)
}